module.exports = __webpack_public_path__ + "assets/img/00187.603bf573.png";